var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenterScanIconblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .center-scan-1 {\n        fill: #0052ff50;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M4.4,6.1c0-.94.76-1.7,1.7-1.7h3.4c.94,0,1.7-.76,1.7-1.7s-.76-1.7-1.7-1.7h-3.4C3.28,1,1,3.28,1,6.1v3.4c0,.94.76,1.7,1.7,1.7s1.7-.76,1.7-1.7v-3.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M31.6,29.9c0,.94-.76,1.7-1.7,1.7h-3.4c-.94,0-1.7.76-1.7,1.7s.76,1.7,1.7,1.7h3.4c2.82,0,5.1-2.28,5.1-5.1v-3.4c0-.94-.76-1.7-1.7-1.7s-1.7.76-1.7,1.7v3.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M4.4,29.9c0,.94.76,1.7,1.7,1.7h3.4c.94,0,1.7.76,1.7,1.7s-.76,1.7-1.7,1.7h-3.4c-2.82,0-5.1-2.28-5.1-5.1v-3.4c0-.94.76-1.7,1.7-1.7s1.7.76,1.7,1.7v3.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M29.9,4.4c.94,0,1.7.76,1.7,1.7v3.4c0,.94.76,1.7,1.7,1.7s1.7-.76,1.7-1.7v-3.4c0-2.82-2.28-5.1-5.1-5.1h-3.4c-.94,0-1.7.76-1.7,1.7s.76,1.7,1.7,1.7h3.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M7.8,14.6c0,.94.76,1.7,1.7,1.7h5.1c.94,0,1.7-.76,1.7-1.7v-5.1c0-.94-.76-1.7-1.7-1.7h-5.1c-.94,0-1.7.76-1.7,1.7v5.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M7.8,26.5c0,.94.76,1.7,1.7,1.7h5.1c.94,0,1.7-.76,1.7-1.7v-5.1c0-.94-.76-1.7-1.7-1.7h-5.1c-.94,0-1.7.76-1.7,1.7v5.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M19.7,14.6c0,.94.76,1.7,1.7,1.7h5.1c.94,0,1.7-.76,1.7-1.7v-5.1c0-.94-.76-1.7-1.7-1.7h-5.1c-.94,0-1.7.76-1.7,1.7v5.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "center-scan-1",
    d: "M19.7,26.5c0,.94.76,1.7,1.7,1.7h5.1c.94,0,1.7-.76,1.7-1.7v-5.1c0-.94-.76-1.7-1.7-1.7h-5.1c-.94,0-1.7.76-1.7,1.7v5.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterScanIconblue);
export default __webpack_public_path__ + "static/media/center-scan-icon.blue.dc31a1b4f9373b4f4c94d4f42cb2ae9d.svg";
export { ForwardRef as ReactComponent };